import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ThreeLinesDiagonalIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M19.0208 6.29289C19.4113 5.90237 20.0445 5.90237 20.435 6.29289 20.8256 6.68342 20.8256 7.31658 20.435 7.70711L7.70711 20.435C7.31658 20.8256 6.68342 20.8256 6.29289 20.435 5.90237 20.0445 5.90237 19.4113 6.29289 19.0208L19.0208 6.29289zM19.7279 12.6569C20.1184 12.2664 20.7516 12.2664 21.1421 12.6569 21.5326 13.0474 21.5326 13.6806 21.1421 14.0711L14.0711 21.1422C13.6805 21.5327 13.0474 21.5327 12.6568 21.1422 12.2663 20.7517 12.2663 20.1185 12.6568 19.728L19.7279 12.6569zM21.1421 19.728C20.7516 19.3374 20.1184 19.3374 19.7279 19.728 19.3374 20.1185 19.3374 20.7516 19.7279 21.1422 20.1184 21.5327 20.7516 21.5327 21.1421 21.1422 21.5326 20.7516 21.5326 20.1185 21.1421 19.728z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
